export class CustomerCreateModel {
  clientId!: number;
  customerId!: number;
  customerName!: string;
  smsCustomerName!: string;
  customerMobnoPri!: string;
  customerMobnoSec?: string | null;

  customerAddress!: string;
  customerCity!: string;
  customerPinCode!: number;

  customerEmailId?: string | null;
  customerGstNo?: string | null;

  customerIsActive!: 'YES' | 'NO';

  constructor(init?: Partial<CustomerCreateModel>) {
    Object.assign(this, init);
  }
}
